import { Fragment, useState, useEffect } from "react";
import "./style.css";

import EachSubCategory from "../EachSubCategoryBoxes/EachSubCategory";
import EachListSubCategory from "../EachListSubCategory/EachListSubCategory";
import Pagination from "Pages/Category/Pagination/Pagination";
import { Spinner } from "react-bootstrap";
import { Grid, FilterRight, ViewList } from "react-bootstrap-icons";

import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBusinesses } from "Redux/Actions/CategoryActions";
import { dispatchItemToRedux } from "Redux/Actions/CommonActions";
import ReducerTypes from "Redux/Types/ReducerTypes";

const AllCategoryBoxes = ({ catBox }) => {
  const dispatch = useDispatch();
  const businesses = useSelector((state) => state.category.businesses.items);
  const pagination = useSelector(
    (state) => state.category.businesses.paginationData
  );
  const loading = useSelector((state) => state.app.appLoading);
  const reqParams = useSelector((state) => state.category.requestParams);

  const { pathname } = useLocation();

  const [showSubCategory, setShowSubCategory] = useState(false);

  useEffect(() => {
    if (reqParams.id) {
      dispatch(getBusinesses());
    }
  }, [reqParams]);

  useEffect(() => {
    const [_, section, id] = pathname.split("/");
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          id,
          section,
        },
      })
    );
  }, [pathname]);

  const options1 = [
    {
      label: "جدید ترین ها",
      value: "new",
    },
    {
      label: "برترین ها ",
      value: "stars",
    },
  ];

  const ListShowHnndler = () => {
    setShowSubCategory(true);
  };

  const BoxShowHnndler = () => {
    setShowSubCategory(false);
  };

  const handleChange = ({ target }) => {
    const filter = target.value === "stars" ? "stars" : "";
    dispatch(
      dispatchItemToRedux({
        type: ReducerTypes.PARAMS,
        payload: {
          id: reqParams.id,
          section: reqParams.section,
          filter: filter,
        },
      }) 
    );
  };

  return (
    <Fragment>
      <div className="filter-box-sub-category  d-flex justify-content-start align-items-center  bg-shiri py-2 px-1 mb-2 align-items-center ">
        <FilterRight
          className="filter-bar-icon ms-2 border-start border-start ps-1"
          size={30}
        />
        <p className="how-filter m-0 ms-2 text-nowrap ">فیلتر بر اساس </p>
        <div className="select-boxes d-flex justify-content-between align-items-center ms-auto">
          <select
            onChange={handleChange}
            className="select-filter ms-2 border-0 rounded-pill px-2  cursor-po bg-white"
          >
            {options1.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <p className="how_display m-0  ms-2 font-site ">نحوه نمایش</p>
        <ViewList
          className={
            showSubCategory
              ? " bg-dap-success p-1 rounded  cursor-po ms-2"
              : " bg-white p-1 rounded cursor-po ms-2"
          }
          size={30}
          onClick={ListShowHnndler}
          color={showSubCategory ? "white" : "black"}
        />
        <Grid
          className={
            showSubCategory
              ? "bg-white p-1 rounded cursor-po"
              : "bg-dap-success p-1 rounded cursor-po"
          }
          size={30}
          onClick={BoxShowHnndler}
          color={showSubCategory ? "black" : "white"}
        />
      </div>

      <div className="all-box-sub-category d-flex flex-wrap justify-content-start py-2 ">
        {loading ? (
          <div className=" w-100 text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          businesses.map((eachDetailBusinesses) => {
            return showSubCategory ? (
              <EachListSubCategory
                key={eachDetailBusinesses.id}
                address={eachDetailBusinesses.address}
                discount={eachDetailBusinesses.discount}
                shop_name={eachDetailBusinesses.shop_name}
                sub_category_name={eachDetailBusinesses.sub_category_name}
                tel={eachDetailBusinesses.tel}
                stars_avg={eachDetailBusinesses.stars_avg}
                select_icon={eachDetailBusinesses.selected_img}
              />
            ) : (
              <EachSubCategory
                key={eachDetailBusinesses.id}
                address={eachDetailBusinesses.address}
                discount={eachDetailBusinesses.discount}
                shop_name={eachDetailBusinesses.shop_name}
                sub_category_name={eachDetailBusinesses.sub_category_name}
                tel={eachDetailBusinesses.tel}
                category_id={eachDetailBusinesses.category_id}
                stars_avg={eachDetailBusinesses.stars_avg}
                select_icon={eachDetailBusinesses.selected_img}
              />
            );
          })
        )}
      </div>

      <Pagination
        catBox={catBox}
        current_page={pagination.current_page}
        last_page={pagination.last_page}
        first_page_url={pagination.first_page_url}
      />
    </Fragment>
  );
};

export default AllCategoryBoxes;
